<template>
  <vxe-table border resizable show-overflow keep-source :data="tableData">
    <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
    <vxe-table-column
      v-for="(item, index) of tableColumn"
      :key="index"
      :field="item.field"
      :title="item.title"
      :edit-render="item.itemRender"
      :minWidth="item.width"
    >
      <template v-slot="{ row }">
        <template v-if="item.field === 'approvalType'">
          {{ translateApprovalType(row.approvalType) }}
        </template>
        <template v-else-if="item.field === 'approvalStatus'">
          {{ translateApprovalStatus(row.approvalStatus) }}
        </template>
        <template v-else>{{ row[item.field] }}</template>
      </template>
    </vxe-table-column>
  </vxe-table>
</template>

<script>
  export default {
    name: 'ApprovalRecordTable',
    props: {
      fetchTableData: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        tableColumn: [
          {
            title: '单据类型',
            field: 'approvalType',
            width: 120,
          },
          {
            title: '审批时间',
            field: 'approvalDate',
            width: 180,
          },
          {
            title: '审批人',
            field: 'approvalPersonName',
            width: 180,
          },
          {
            title: '部门',
            field: 'approvalDepartmentName',
            width: 180,
          },
          {
            title: '反馈意见',
            field: 'approvalComment',
            width: 180,
          },
          {
            title: '审批状态',
            field: 'approvalStatus',
            width: 180,
          },
          {
            title: '备注',
            field: 'remark',
            width: 180,
          },
        ],
        tableData: [],
        approvalTypeList: [],
        approvalStatusList: [],
      };
    },
    mounted() {
      this.approvalTypeList = this.dictListMap.SuperviseBillApprovalType;
      this.approvalStatusList = this.dictListMap.SuperviseBillApprovalStatusType;
      console.log(this.approvalTypeList, '单据类型');
    },
    methods: {
      // 翻译监管单状态
      translateApprovalType(val) {
        return this.approvalTypeList.find((item) => item.value == parseInt(val))?.label;
      },
      // 翻译审批状态
      translateApprovalStatus(val) {
        return this.approvalStatusList.find((item) => item.value == parseInt(val))?.label;
      },
    },
    watch: {
      fetchTableData: {
        handler(val) {
          if (val && val.length) {
            this.tableData = val;
          }
        },
        immediate: true,
      },
    },
  };
</script>

<style lang="scss" scoped></style>
